var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "edit_svg__path-1",
    d: "m23.133 2.733-1.9-1.9a2.676 2.676 0 0 0-3.766 0L2.4 15.933a1.65 1.65 0 0 0-.467.967L.1 23.033c-.067.234 0 .5.167.667.133.133.3.2.466.2.067 0 .134 0 .2-.033L7.1 22.033c.367-.033.7-.2.967-.466l15.1-15.1c1-1 1-2.667-.034-3.734M2.8 18.7l2.5 2.5-3.567 1.067zM22.2 5.567 20.667 7.1 16.9 3.333 18.433 1.8a1.33 1.33 0 0 1 1.9 0l1.9 1.9c.467.5.467 1.367-.033 1.867"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__icons-badges-variations",
    transform: "translate(-528 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__icons/edit",
    transform: "translate(528 237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "edit_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit_svg__path-1",
    id: "edit_svg__edit",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "edit_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#edit_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  })))))));
};
export default SvgEdit;